"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxRuleConditionDataArgs = void 0;
var HxInboxRuleAddressDataArgs_1 = require("./HxInboxRuleAddressDataArgs");
function serializeHxRuleConditionDataArgs(_arg) {
    var output = [];
    output.push(_arg.type);
    var searchStringsOutput = [];
    _arg.searchStrings.forEach(function (item) { return searchStringsOutput.push(item); });
    output.push(searchStringsOutput);
    var recipientsOutput = [];
    _arg.recipients.forEach(function (item) { return recipientsOutput.push(HxInboxRuleAddressDataArgs_1.serializeHxInboxRuleAddressDataArgs(item)); });
    output.push(recipientsOutput);
    var categoryNameOutput = [];
    _arg.categoryName.forEach(function (item) { return categoryNameOutput.push(item); });
    output.push(categoryNameOutput);
    return output;
}
exports.serializeHxRuleConditionDataArgs = serializeHxRuleConditionDataArgs;
